<template>
    <v-row class="mx-1 mb-2" dense>
        <v-col cols="6" sm="4" md="2">
            <v-card
                outlined
                :class="['indicator-card', activeFilter === null ? 'indicator-card--active' : '']"
                @click="filterByStatus(null)"
                :ripple="true"
            >
                <v-card-text class="text-center pa-3">
                    <v-icon color="primary" class="mb-1">mdi-file-document-multiple-outline</v-icon>
                    <div class="text-h5 font-weight-bold primary--text">{{ loading ? '...' : indicators.total }}</div>
                    <div class="caption grey--text">Total</div>
                </v-card-text>
            </v-card>
        </v-col>
        <v-col v-for="item in indicators.by_status" :key="item.id" cols="6" sm="4" md="2">
            <v-card
                outlined
                :class="['indicator-card', activeFilter === item.id ? 'indicator-card--active' : '']"
                @click="filterByStatus(item.id)"
                :ripple="true"
            >
                <v-card-text class="text-center pa-3">
                    <v-icon :color="statusColor(item.id)" class="mb-1">{{ statusIcon(item.id) }}</v-icon>
                    <div class="text-h5 font-weight-bold" :class="statusColor(item.id) + '--text'">{{ loading ? '...' : item.total }}</div>
                    <div class="caption grey--text">{{ item.name }}</div>
                </v-card-text>
            </v-card>
        </v-col>
    </v-row>
</template>

<script>
import { mapActions } from 'vuex'

const STATUS_CONFIG = {
    1: { color: 'orange',  icon: 'mdi-timer-sand' },
    2: { color: 'success',  icon: 'mdi-check-circle' },
    3: { color: 'grey',     icon: 'mdi-cancel' },
}

const DEFAULT_CONFIG = { color: 'blue-grey', icon: 'mdi-help-circle-outline' }

export default {
    name: "SysTermSignatureIndicators",
    data: () => ({
        loading: false,
        activeFilter: null,
        indicators: {
            total: 0,
            by_status: [],
        },
    }),
    mounted() {
        this.loadIndicators()
    },
    methods: {
        ...mapActions('term', ['ActionIndexTermSignatureIndicators']),

        loadIndicators() {
            this.loading = true
            this.ActionIndexTermSignatureIndicators()
                .then((res) => {
                    if (res && res.data) {
                        this.indicators = res.data
                    }
                })
                .finally(() => {
                    this.loading = false
                })
        },

        filterByStatus(statusId) {
            this.activeFilter = statusId === this.activeFilter ? null : statusId
            this.$emit('filter', this.activeFilter)
        },

        statusColor(id) {
            return (STATUS_CONFIG[id] || DEFAULT_CONFIG).color
        },

        statusIcon(id) {
            return (STATUS_CONFIG[id] || DEFAULT_CONFIG).icon
        },
    },
}
</script>

<style scoped>
.indicator-card {
    cursor: pointer;
    transition: all 0.2s ease;
    border: 2px solid transparent !important;
}

.indicator-card:hover {
    transform: translateY(-2px);
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.12) !important;
}

.indicator-card--active {
    border-color: var(--v-primary-base) !important;
    background-color: rgba(var(--v-primary-base), 0.04);
}
</style>
